import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="mx-auto max-w-7xl px-4 py-24 text-center sm:px-6 lg:px-8" data-testid="not-found-page">
      <p className="font-heading text-7xl font-extrabold text-[#0F4C5C]">404</p>
      <h1 className="font-heading mt-4 text-2xl font-bold text-slate-900">{t("notFound.title")}</h1>
      <p className="mx-auto mt-3 max-w-md text-slate-600">
        {t("notFound.sub")}
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 border border-[#0F4C5C] px-5 py-2.5 text-sm font-bold text-[#0F4C5C]" data-testid="not-found-home-btn">
          {t("common.backToHome")} <ArrowRight className="h-4 w-4" />
        </Link>
        <a href="tel:+19545402539" className="inline-flex items-center gap-2 bg-[#0F4C5C] px-5 py-2.5 text-sm font-bold text-white" data-testid="not-found-call-btn">
          <Phone className="h-4 w-4" /> 954-540-2539
        </a>
      </div>
    </div>
  );
}
